import { SDK_FRAGMENT_NAME } from '@msdyn365-commerce/core-internal';
import * as React from 'react';
import { getPublicAssetPath } from '../../shared/functions/msdyn-helpers';

import { ICusPublicAssetPreloadProps } from './cus-public-asset-preload.props.autogenerated';

export default (props: ICusPublicAssetPreloadProps<never>) => {
    const { config, context } = props;

    return (
        <>
            {config.assetsToPreload.map(asset => {
                const href = getPublicAssetPath(context, asset.assetPath);
                let attrs = `rel="preload" as="${asset.preloadAs}" href="${href}"`;

                if (asset.preloadAs === 'font') {
                    attrs += ' crossorigin="anonymous"';

                    const extension = href
                        .split('.')
                        .pop()
                        ?.toLowerCase();
                    if (extension) {
                        attrs += ` type="font/${extension}"`;
                    }
                }

                const element = `<link ${attrs} />`;

                return React.createElement(SDK_FRAGMENT_NAME, { key: asset.assetPath, dangerouslySetInnerHTML: { __html: element } });
            })}
        </>
    );
};
